import { useState } from "react";

import {
  Box,
  Button,
  Divider,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";

import { useShipmentFiltersContext } from "hooks";
import { getActiveFiltersCount } from "utils/shipment";

import { CompactShipmentPreview } from "../ShipmentPreview";

interface Props {
  shipments: CarrierCondensedShipment[];
  shipmentSelectionIsDisabled: boolean;
  handlePageSelected: (e: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  pages: number;
}

export function QuickShipmentsBrowser(props: Props) {
  const {
    shipments,
    shipmentSelectionIsDisabled,
    handlePageSelected,
    page,
    pages,
  } = props;

  const params = useParams();
  const shipmentId = params.id;
  const { filters, clearFilters } = useShipmentFiltersContext();
  const activeFiltersCount = getActiveFiltersCount(filters);

  const [selected, setSelected] = useState<number | undefined>(
    shipmentId ? +shipmentId : undefined,
  );

  if (shipments.length === 0 && activeFiltersCount > 0) {
    return (
      <Box
        boxShadow={1}
        display="flex"
        flexDirection="column"
        height="calc(100vh - 250px)"
      >
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          sx={{ flex: 1, p: 2, pt: 6 }}
        >
          <Typography sx={{ textAlign: "center" }} variant="body1">
            No shipments found with current filters.
          </Typography>
          <Button variant="outlined" onClick={clearFilters}>
            Clear Filters
          </Button>
        </Stack>
      </Box>
    );
  }

  return (
    <Box
      boxShadow={1}
      display="flex"
      flexDirection="column"
      height="calc(100vh - 250px)"
    >
      <Box sx={{ flex: 1, overflowY: "scroll", overflowX: "hidden" }}>
        {shipments.map((s, i) => (
          <Box key={s.info.id}>
            {i > 0 && <Divider />}
            <CompactShipmentPreview
              shipment={s}
              selected={s.info.id === selected}
              select={setSelected}
              selectionIsDisabled={shipmentSelectionIsDisabled}
            />
          </Box>
        ))}
      </Box>
      <Divider />
      <Box my="1rem" display="flex" alignItems="center" justifyContent="center">
        <Pagination count={pages} onChange={handlePageSelected} page={page} />
      </Box>
    </Box>
  );
}
